<template>
  <div class="loginWrap">
    <div class="login-content">
      <div class="login-img">
        <img class="login-imgs" src="../../public/static/images/login.png">
      </div>
      <div class="login-bg">
        <div class="login-bg-title">
          {{$t('append_field.welcome')}}
        </div>
        <div class="login-input-call">
          <div class="login-input-item">
            <div class="login-input-label">
              <i class="icon etv etv-account"></i>
            </div>
            <van-field  :clearable="true"  v-model="userName" :placeholder="$t('append_field.enter_account')"/>
          </div>
          <div class="login-input-item">
            <div class="login-input-label">
              <i class="etv icon etv-password"></i>
            </div>
            <van-field v-model="userPwss" :clearable="false" :placeholder="$t('append_field.enter_password')"
                       :type="passwordFieldType">
              <template #button >
                <van-icon
                    :name="showPassword ? 'eye-o' : 'closed-eye'"
                    @click="togglePassword"
                />
              </template>
            </van-field>
          </div>
          <div class="login-input-item">

            <van-field v-model="keycodeLogin" :clearable="true" :placeholder="$t('append_field.input_code')">
            </van-field>
            <codeKey ref="codeKey" slot="append" @update:uuid="setUuid" ></codeKey>

          </div>
          <div style="display: flex; justify-content: space-between;">
            <van-checkbox v-model="rememberMe" style="flex: 1; justify-content: flex-end">{{$t('append_field.remember_password')}}</van-checkbox>
          </div>
        </div>
      </div>
      <div class="login-btn" style="padding-bottom: 30px">
        <van-button block class="landing" @click="login">
          {{$t('append_field.login2')}}
        </van-button>
      </div>
      <div class="login-btn lang" >
        <div>
         <lang-select/>
        </div>
        <!--   /*
        *
        *
        版本号生成规则
        主版本号.子版本号.修订版本号-日期(YYMMDD)
        V6.0.6-241011
        注：
        主版本号，当你做了不兼容的 API 修改时递增。
        次版本号，当你添加了向下兼容的功能时递增。
        修订号，当你进行向下兼容的错误修正时递增,每次修改小问题时加1。
        */     -->
        <div>
          <van-cell center :title="sysVersion()">
          </van-cell>
        </div>
        <div>
          <more-select  :userName="userName" :registerUser="registerUser"/>
        </div>
      </div>
    </div>
    <van-dialog  v-model="isPassVerify" :title="diaTitle[type]"
                 show-cancel-button
                 @confirm="uuidLogin"
                 :beforeClose="vBeforeClose"
                 @cancel="close">
      <div class="passVerify-content">
        <div class="passVerify-explain">{{$t('append_field.please_authenticate_for_account_safety')}}</div>
        <div class="passVerify-email">
          <span>{{ passBind }}</span>
          <div class="passVerify-opt" v-if="environment=='local'">
            <van-button v-if="type===1"
                        v-show="showButton"
                        style="
            color: #00a2fe;
            border: none;
            background-color:transparent;"
                        @click="selectedOption(0)">
              {{$t('append_field.phone_number')}}
            </van-button>
            <van-button v-if="type===0"
                        v-show="showButton"
                        style="
            color: #00a2fe;
            border: none;
            background-color:transparent;"
                        @click="selectedOption(1)">
              {{$t('append_field.email')}}
            </van-button>
          </div>
        </div>
        <div class="passVerify-code">
          <input type="number" v-model="uuidCode" >
          <van-button :disabled="getCodeing" color="#006EFF" @click="getUuidCode()" >{{ uuidCodeText }}</van-button>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import CryptoJS from 'crypto-js'
import qs from 'qs'
import { Toast } from 'vant'
import LangSelect from "@/components/langSelect.vue";
import codeKey from '@/components/Vsidentify.vue'
import {environment, sysVersion} from "@/assets/js/user_environment";
import {vBeforeClose} from "@/utils/tool";
import MoreSelect from "@/components/moreSelect.vue";

function decode(data) {
  try {
    var key = '79697368656e67746563686e6f6c6f6779636f6d70616e793230313930343131'
    key = CryptoJS.enc.Hex.parse(key)
    let iv = CryptoJS.enc.Hex.parse('79697368656e67746563684032303139')
/*    console.log(key);
    console.log(iv);*/

    var dec = CryptoJS.AES.decrypt(CryptoJS.format.Hex.parse(data.data), key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    })

    return JSON.parse(CryptoJS.enc.Utf8.stringify(dec))
  } catch (e) {
    console.warn(e)
  }
  return ''

}
function encrypt(data) {
  var key = '79697368656e67746563686e6f6c6f6779636f6d70616e793230313930343131'
  key = CryptoJS.enc.Hex.parse(key)
  let iv = CryptoJS.enc.Hex.parse('79697368656e67746563684032303139')
  var enc = CryptoJS.AES.encrypt(data, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  })
  var enced = enc.ciphertext.toString()
  return enced
}
function decrypt(encryptedData) {
  var key = CryptoJS.enc.Hex.parse('79697368656e67746563686e6f6c6f6779636f6d70616e793230313930343131');
  let iv = CryptoJS.enc.Hex.parse('79697368656e67746563684032303139');
  var decrypted = CryptoJS.AES.decrypt({
    ciphertext: CryptoJS.enc.Hex.parse(encryptedData)
  }, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });

  return decrypted.toString(CryptoJS.enc.Utf8);
}

export default {
  name: 'Login',
  components: {MoreSelect, LangSelect, codeKey },
  data() {
    return {
      identifyCode: '',
      showPicker: false,
      userName: localStorage.getItem("userName")||'',
      userPwss: '',
      keycodeLogin: '',
      topTitle: this.$t('append_field.login'),
      show: true,
      isPassVerify: false,
      passBindPhone: "131****3215",
      uuid: "",
      uuidCode: "",
      uuidCodeText: this.$t('append_field.verification_code'),
      getCodeing: false,
      getPass: {
        userPhoneRetrieve: '',
        userPassRetrieve: '',
        userPassNewRetrieve: '',
        codeNumberRetrieve: '',
      },
      loading: false,
      platformType:1,
      type: 1,
      showButton: true,
      passBind: '',
      rememberMe:false,
      diaTitle:[this.$t('append_field.sms_verification'),this.$t('append_field.email_verification')],
      showPassword: false, // 控制密码可见性的布尔变量
      passwordFieldType: 'password', // 密码输入框的类型
      newUuid:'',
      //海外隐藏手机验证切换按钮
      environment,
      registerUser:'0',//注册入口显示
    }
  },

  mounted() {
    this.Flush()
    document.title = this.$t('append_field.login')
    window.onresize = () => {
      return (() => {
        this.handleLableWidth()
      })()
    }
    this.handleLableWidth()
    this.loadCredentials()
    this.setUuid()
    this.getMainConfig()
  },
  methods: {
    sysVersion() {
      return sysVersion
    },
    vBeforeClose,
    setUuid(newUuid) {
      this.newUuid = newUuid
    },
    Flush() {
      this.identifyCode = ''
      for (let i = 0; i < 4; i++) {
        this.identifyCode += parseInt(Math.random() * 10)
      }
    },
    //重置密码

    //取消按钮
    close(){
      this.isPassVerify=false
      this.uuidCode=""
    },
    //记住密码
    loadCredentials() {
      // 页面加载时，尝试从本地存储加载加密的用户名和密码
      this.rememberMe = localStorage.getItem('rememberMe')
      const storedUserName = localStorage.getItem('userName')
      const storedUserPwss = localStorage.getItem('userPwss')
      if (storedUserName && storedUserPwss) {
        // 如果找到了，解密并填充到表单中
        this.userName = storedUserName
        this.userPwss = decrypt(storedUserPwss)
      }
    },
    //获取验证码
    getUuidCode() {

      this.$ajax.post("/etv/getSecondConfirmSmsCode.json", qs.stringify({
        uuid: this.uuid,
        type:this.type
      })).then(res => {
        if (res.data.code === 0) {
          if (this.getCodeing) {
            return
          }
          this.getCodeing = true
          let i = 60
          this.uuidCodeText = `${i}`+'s'
          let timer = setInterval(() => {
            i--
            this.uuidCodeText = `${i}`+'s'
            if (i === 0) {
              this.getCodeing = false
              timer && clearInterval(timer)
              this.uuidCodeText = this.$t('append_field.verification_code')
            }
          }, 1000)
          Toast(res.data.msg)

        }else {
          Toast(res.data.msg)
        }
      })
    },
    getInifData() {
      this.$ajax.post('/etv/getUploadServer.json').then(res => {
        if (res.data.code === 0) {
          localStorage.setItem("upFileUrl", res.data.data)
          //localStorage.setItem('upFileUrl','http://192.168.5.50:8899/')
          this.$router.push('/information')
        }
      })
    },
    handleLableWidth() {
      if (document.activeElement.tagName == 'INPUT' || document.activeElement.tagName == 'TEXTAREA') {
        window.setTimeout(function () {
          document.activeElement.scrollIntoViewIfNeeded()
        }, 0)
      }
    },
    login() {
      if(!this.userName){
        Toast(this.$t('append_field.username_cannot_be_empty'))
        return
      }
      if(!this.userPwss){
        Toast(this.$t('append_field.password_cannot_be_empty'))
        return
      }
      if(!this.keycodeLogin){
        Toast(this.$t('append_field.fill_code'))
        return;
      }
      localStorage.removeItem('isPushNotice')
      this.$ajax.post('/etv/login.htm', qs.stringify({
        'username': encrypt(this.userName),
        'password': encrypt(this.userPwss),
        'platformType':1,
        'verifyCode': this.keycodeLogin,
        'uuid': this.newUuid
      })).then(res => {
        // 登录逻辑...
        if (this.rememberMe) {
          // 如果用户选择记住密码，将账号和密码保存到本地存储
          localStorage.setItem('userName',this.userName)
          localStorage.setItem('userPwss', encrypt(this.userPwss))
          localStorage.setItem('rememberMe', this.rememberMe)

        }else{
          const usr = localStorage.getItem('userName')
          localStorage.setItem('userName',this.userName)
          if(usr === this.userName){
            localStorage.setItem('userName',this.userName)
            localStorage.setItem('userPwss','')
            localStorage.setItem('rememberMe','')
          }
        }
        // 继续登录逻辑...
        let code = res.data.code
        this.passBind = res.data.email
        this.email = res.data.email
        let passBindPhone=res.data.phone
        if (code === 0) {
          let data = decode(res.data)
          Toast(res.data.msg)

          localStorage.setItem('token', data.token)
          localStorage.setItem('userId', data.id)
          localStorage.setItem('username', data.username)
          localStorage.setItem('isSafePwd', data.isSafePwd)
          localStorage.setItem('level',data.level)
          localStorage.setItem('roleId',data.roleId)
          localStorage.setItem('spPermissions',data.spPermissions)
          if(!data.isSafePwd){
            this.$router.replace("/editPass")
            return
          }
          this.getInifData()
        } else if(res.data.code===6001){
          this.isPassVerify = true
          this.passBindPhone = res.data.phone
          this.uuid = res.data.uuid
          this.email=res.data.email
          if (this.email === '') {
            this.type=0
            if(passBindPhone.length>10){
              this.showButton = false
              this.passBind = this.passBindPhone
            }else {
              this.isPassVerify = false
              Toast(this.$t('append_field.incorrect_phone_format_for_verification_code'))
            }
          } else if (this.passBindPhone === '') {
            this.type=1
            if(this.email.includes('@')){
              this.showButton = false
              this.passBind = this.email
            }else {
              this.isPassVerify = false
              Toast(this.$t('append_field.incorrect_email_format_for_verification_code'))
            }
          }
        }else {
          this.$refs.codeKey.getCode()
          Toast(res.data.msg)
          this.uuidCodeText = this.$t('append_field.verification_code')
        }
        this.loading = false
      })
    },
    goto() {
      this.$router.push('/Register')
    },
    uuidLogin() {
      this.$ajax.post("/etv/smsCodeConfirmLogin.json", qs.stringify({
        uuid: this.uuid,
        smsCode: this.uuidCode,
        type: this.type
      })).then(res => {
        if (res.data.code === 0) {
          let data = decode(res.data)
          localStorage.setItem('token', data.token)
          localStorage.setItem('userId', data.id)
          localStorage.setItem('username', data.username)
          localStorage.setItem('isSafePwd', data.isSafePwd)
          localStorage.setItem('level',data.level)
          localStorage.setItem('roleId',data.roleId)
          localStorage.setItem('spPermissions',data.spPermissions)
          if(!data.isSafePwd){
            this.$router.replace("/editPass")
            return
          }
          this.getInifData()

        } else {
          Toast(res.data.msg)
        }
      })
    },
    selectedOption(option) {
      this.type = option
      this.showButton = true
      if (this.type === 0) {
        this.passBind = this.passBindPhone
      } else {
        this.passBind = this.email
      }
    },
    togglePassword(){
      // 切换密码的可见性
      this.showPassword = !this.showPassword
      // 根据密码的可见性状态切换输入框的类型
      this.passwordFieldType = this.showPassword ? 'text' : 'password'
    },
    getMainConfig(){
      this.$ajax.get('/etv/getMainConfig.json').then(res => {
        if (res.data.code === 0) {
          //注册入口显示
          this.registerUser=res.data.data['sys.account.registerUser']

        }
      })
    },
  },

}
</script>

<style lang="scss">
@import "../../public/static/css/app";

.van-popup--center {
  width: 90%;
  border-radius: 10px;
  .content-module {
    width: 100%;
    height: auto;
    margin: 0 auto;
    padding: 10px 10px 20px 10px;
    box-sizing: border-box;


    div {
      line-height: 40px;
      font-size: 18px !important;
      font-weight: bold;
      margin-bottom: 10px;
      text-align: center;
    }

    p {
      margin-bottom: 10px;
      text-indent: 2em;
      line-height: 1.5;
    }
  }
}


.loginWrap {
  height: 100%;
  overflow-y: auto;
}
.van-dialog__header{
  font-size: 18px !important;
  font-weight: bold;
}
.topTitle {
  height: 40px;
  background: #006EFF;
  line-height: 40px;
  text-align: center;
  color: #fff;
}

.login-content {
  position: relative;
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 100%;
  padding-bottom: 35px;

  .login-img {
    margin-top: 30px;
    padding: 0 20px;
    margin-bottom: 20px;

    .login-imgs {
      width: 100%;

    }
  }
  .login-bg {
    padding: 9px 40px;
    box-sizing: border-box;

    .login-bg-title {
      font-size: 22px !important;
      font-weight: 700;
      color: $uni-text-color;
      margin-bottom: 25px;
    }

    .login-input-call {
      .login-input-item {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        border-bottom: 1px solid $uni-border-bottom-color;
        .van-field__button{
          padding-left: 0px;
        }
        .van-field {
         background: none;
        }
        .van-icon {

          position: absolute; /* 绝对定位图标 */
          right: 5px; /* 从右边留出一些空间，根据实际情况调整 */
          top: 50%; /* 垂直居中 */
          transform: translateY(-50%); /* 确保垂直居中 */
          cursor: pointer; /* 将鼠标光标改为指针，表示可点击 */
          background: none;

        }
        .login-input-label {
          color: $uni-border-bottom-color;
          margin-right: 10px;

          i {
            font-size: 24px;
          }
        }

        .nut-textinput {
          flex: 1;

          input {
            background: none;
          }
        }

        input {
          border-radius: 0;
          border: none;
        }

      }

      .login-input-item:nth-of-type(2) {
        margin-bottom: 10px;
      }

      .editServe {
        height: 20px;
        line-height: 20px;
        text-align: right;
        color: #999;
        font-size:  15px;
      }

    }
  }

  .login-btn {
    padding: 0 40px;
    margin-top: 15px;

    .landing {
      border-radius: 3px;
      font-size: 16px;
      font-weight: 700;
      letter-spacing: 3px;
      color: $uni-text-color-inverse;
      background: $uni-color-primary;
    }
  }

  .aq {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 25px;
    line-height: 25px;
    text-align: center;
    background: #2c3e50;
    color: white;
    font-size:  15px;
    display: inline-block;
    text-decoration: none;
  }

}
.van-dialog{
  width: 100%;
  .van-dialog__confirm {
    color: #006EFF;
  }

  .van-dialog__confirm:active {
    color: #006EFF;
  }
  .passVerify-content{
    padding:10px 20px;
    .passVerify-explain {
      height: 30px;
      margin: 10px 0;
      //white-space: nowrap
    }

    .passVerify-phone {
      height: 30px;
    }

    .passVerify-email {
      height: 30px;
      display: flex;
      justify-content: space-between;
      .passVerify-opt{
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .passVerify-code {
      display: flex;
      border: 1px solid #cccccc;
      margin:20px 0 20px 0;
      align-items: center;
      border-radius: 6px;
      overflow: hidden;
      input {
        border: none;
        outline: none;
        height: 38px;
        flex: 1;
        padding-left: 5px;
      }
      .getCode {
        width: 80px;
        cursor: pointer;
        height: 100%;
        border: none;
        padding: 0px;
        line-height: 1px;
        color: $uni-text-color-inverse;
        background: $uni-color-primary;
      }
      .van-button{
        border-radius: 0px !important;
      }
    }
  }
}
.lang{
  font-size:  15px;
  display: flex;
  justify-content: space-between;
  position: absolute;
  bottom: 0;
  margin: auto;
  left: 0;
  right: 0;
  align-items: center;
  text-align: center;
  .van-cell{
    background: none;
  }
}

</style>
